var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMobile } from '../common/hooks/use-mobile';
import { isClickable, transformStyle } from '../common/utils/index';
import { useWrapStyle } from '../common/hooks/use-wrap-style';
import { useDesignContext } from '../design-provider';
var showStyle = {
  1: '1 shadow bg-white rounded-md text-sm flex justify-center items-center px-2 py-1',
  2: '2 text-sm'
};
export default function Text(props) {
  var text = props.text,
    setMethod = props.setMethod,
    texts = props.texts,
    style = props.style,
    bgSetting = props.bgSetting,
    bgPicture = props.bgPicture,
    bgColor = props.bgColor,
    _props$more = props.more,
    show = _props$more.show,
    moreText = _props$more.text,
    moreStyle = _props$more.style,
    color = _props$more.color,
    operator = _props$more.operator;
  var textAlign = style.textAlign,
    restStyle = __rest(style, ["textAlign"]);
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  var transformedStyle = transformStyle(restStyle, mobile);
  var wrapStyle = useWrapStyle(bgSetting, bgPicture, bgColor);
  if (setMethod !== '2') {
    return _jsxs("div", Object.assign({
      className: classNames('box-border flex text-widget justify-center items-center relative'),
      style: Object.assign(Object.assign({
        lineHeight: 'normal'
      }, transformedStyle), wrapStyle)
    }, {
      children: [_jsx("p", Object.assign({
        className: classNames('flex-1 whitespace-pre-wrap break-words', 'py-4', 'cq-pc:py-2'),
        style: {
          textAlign: textAlign
        }
      }, {
        children: text
      })), show && _jsx("a", Object.assign({
        style: {
          color: color,
          right: "".concat(mobile ? props.style.padding : Number(props.style.padding) * 10, "px")
        },
        className: classNames('absolute text-widget__more', showStyle[moreStyle], {
          'cursor-pointer': isClickable(operator)
        }),
        href: designOnLink(operator)
      }, {
        children: moreText
      }))]
    }));
  }
  return _jsx("div", Object.assign({
    className: classNames('box-border  overflow-x-auto flex text-widget relative hide-scrollbar'),
    style: Object.assign(Object.assign({
      lineHeight: 'normal'
    }, transformedStyle), wrapStyle)
  }, {
    children: _jsx("div", Object.assign({
      className: classNames('width-auto min-w-full  flex flex-nowrap', 'py-4', 'cq-pc:py-2', {
        'justify-center': textAlign === 'center'
      })
    }, {
      children: texts.map(function (i) {
        return _jsx("a", Object.assign({
          className: classNames('ml-6 whitespace-nowrap first:ml-0', 'pc:ml-10 pc:first:ml-0', {
            'cursor-pointer': isClickable(i.target)
          }, 'block'),
          href: designOnLink(i.target)
        }, {
          children: i.title
        }));
      })
    }))
  }));
}